import React, { FC, memo } from 'react';
import Icon, { Icons } from '../Icon';
import { theme } from '../../styles/theme';

export const TriggerIcon: FC<{ isExpanded: boolean }> = memo(({ isExpanded }) => {
    return (
        <div className={`triggerIcon ${isExpanded ? 'isExpanded' : ''}`}>
            {isExpanded ? (
                <Icon name={Icons.Minus} color={theme.colors.black2} height={20} width={10} />
            ) : (
                <Icon name={Icons.Plus} color={theme.colors.black2} height={20} width={10} />
            )}
        </div>
    );
});
TriggerIcon.displayName = 'TriggerIcon';
